import api from "../api";

const state = {
  dashboardGlobalMetrics: {},
  dashboardGlobalMetricsforLast7Days: {},
  dashboardGraphMetrics: {},
  dashboardVideoMetrics: [],
  dashboardPageMetrics: [],
  dashboardExportData: null,
  agencySiteVideosPlays: [],
  agencyVideoMetrics: [],
  agencyPageMetrics: [],
  dashboardDeviceMetrics: {},
  dashboardWidgetMetrics: [],
};

const getters = {
  getDashboardExportData: (state) => state.dashboardExportData,
};

const mutations = {
  dashboardGraphMetrics(state, dashboardGraphMetrics) {
    state.dashboardGraphMetrics = dashboardGraphMetrics;
  },
  dashboardGlobalMetricsforLast7Days(state, dashboardGlobalMetrics) {
    state.dashboardGlobalMetricsforLast7Days = dashboardGlobalMetrics;
  },
  dashboardGlobalMetrics(state, dashboardGlobalMetrics) {
    state.dashboardGlobalMetrics = dashboardGlobalMetrics;
  },
  dashboardVideoMetrics(state, videoMetrics) {
    state.dashboardVideoMetrics = videoMetrics;
  },
  dashboardPageMetrics(state, PageMetrics) {
    state.dashboardPageMetrics = PageMetrics;
  },
  SET_DASHBOARD_EXPORT_DATA(state, data) {
    state.dashboardExportData = data;
  },
  SET_AGENCY_SITE_VIDEOS_PLAYS(state, playsData) {
    state.agencySiteVideosPlays = playsData;
  },
  agencyVideoMetrics(state, videoMetrics) {
    state.agencyVideoMetrics = videoMetrics;
  },
  agencyPageMetrics(state, PageMetrics) {
    state.agencyPageMetrics = PageMetrics;
  },
  dashboardDeviceMetrics(state, deviceMetrics) {
    state.dashboardDeviceMetrics = deviceMetrics;
  },
  dashboardWidgetMetrics(state, deviceMetrics) {
    state.dashboardWidgetMetrics = deviceMetrics;
  },
};

const actions = {
  async dashboardGraphMetrics({ dispatch, commit }, { query, isAgency }) {
    try {
      const dashboardGraphMetrics = isAgency
        ? await api.getAgencyDashboardGraphMetrics(query)
        : await api.getDashboardGraphMetrics(query);
      commit("dashboardGraphMetrics", dashboardGraphMetrics);
    } catch (err) {
      throw err;
    }
  },

  async dashboardGlobalMetrics({ dispatch, commit }, { query, isAgency }) {
    try {
      const dashboardGlobalMetrics = isAgency
        ? await api.getAgencyDashboardGlobalMetrics(query)
        : await api.getDashboardGlobalMetrics(query);
      commit("dashboardGlobalMetrics", dashboardGlobalMetrics);
    } catch (err) {
      throw err;
    }
  },

  async dashboardGlobalMetricsforLast7Days({ dispatch, commit }, query) {
    try {
      const dashboardGlobalMetrics = await api.getDashboardGlobalMetrics(query);
      commit("dashboardGlobalMetricsforLast7Days", dashboardGlobalMetrics);
    } catch (err) {
      throw err;
    }
  },
  async dashboardVideoMetrics({ commit }, query) {
    try {
      const videoMetrics = await api.getDashboardVideoMetrics(query);
      commit("dashboardVideoMetrics", videoMetrics);
    } catch (err) {
      throw err;
    }
  },
  async dashboardPageMetrics({ commit }, query) {
    try {
      const pageMetrics = await api.getDashboardPageMetrics(query);
      commit("dashboardPageMetrics", pageMetrics);
    } catch (err) {
      throw err;
    }
  },
  async exportDashboardDataAction({ commit }, query) {
    try {
      const data = await api.exportDashboardData(query);
      commit("SET_DASHBOARD_EXPORT_DATA", data);

      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `dashboard-data-${query.exportType}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Optionally release memory
      window.URL.revokeObjectURL(url);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async fetchAgencySiteVideosPlays({ commit }, query) {
    try {
      const videosPlaysData = await api.getAgencySiteVideosPlays(query);
      commit("SET_AGENCY_SITE_VIDEOS_PLAYS", videosPlaysData);
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  async agencyVideoMetrics({ commit }, query) {
    try {
      const videoMetrics = await api.getAgencyVideoMetrics(query);
      commit("agencyVideoMetrics", videoMetrics);
    } catch (err) {
      throw err;
    }
  },
  async agencyPageMetrics({ commit }, query) {
    try {
      const pageMetrics = await api.getAgencyPageMetrics(query);
      commit("agencyPageMetrics", pageMetrics);
    } catch (err) {
      throw err;
    }
  },
  async fetchDashboardDeviceMetrics({ commit }, query) {
    try {
      const deviceMetrics = await api.getDashboardDeviceMetrics(query);
      commit("dashboardDeviceMetrics", deviceMetrics);
    } catch (err) {
      throw err;
    }
  },
  async fetchDashboardWidgetMetrics({ commit }, query) {
    try {
      const widgetMetrics = await api.getDashboardWidgetMetrics(query);
      commit("dashboardWidgetMetrics", widgetMetrics);
    } catch (err) {
      throw err;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
